import Group from 'components/utils/Group'
import type { PropsWithChildren } from 'react'
import styled from 'styled-components'

export const AccommodationIndividualSelectRoomOptionTileMessageContainer = styled(Group)`
  position: relative;
`

function AccommodationIndividualSelectRoomOptionTileMessage(props: PropsWithChildren) {
  return <AccommodationIndividualSelectRoomOptionTileMessageContainer
    {...props}
    direction="vertical"
    verticalAlign="end"
    gap={12}
  />
}

export default AccommodationIndividualSelectRoomOptionTileMessage
